export interface Survey {
  surveyId: string;
  name: string;
  status: SurveyStatus;
  intro: SurveyIntro;
  questionGroups: SurveyQuestionGroup[];
  type: string;
}

export interface SurveyIntro {
  image: string;
  completionEstimate: number;
  title: string;
  desc: string;
  cta: string;
}

export interface SurveyQuestionGroup {
  id: string;
  title: string;
  subTitle: string;
  canSkip: boolean;
  skipped: boolean;
  activateWhen: string[];
  inactiveDisplayType?: SurveyQuestionInactiveDisplayType;
  validation: SurveyQuestionGroupValidation;
  questions: SurveyQuestion[];
}

export interface SurveyQuestion {
  questionId: string;
  type: SurveyQuestionType;
  inactiveDisplayType?: SurveyQuestionInactiveDisplayType;
  activateWhen: string[];
  options: SurveyQuestionOption[];
  title?: string;
  placeholder?: string;
  value?: string;
}

export interface SurveyQuestionOption {
  optionId: string;
  selected: boolean;
  title: string;
  inactiveDisplayType?: SurveyQuestionInactiveDisplayType;
  activateWhen: string[];
}

export enum SurveyQuestionInactiveDisplayType {
  HIDDEN = 'HIDDEN',
  DISABLED = 'DISABLED',
}

export enum SurveyStatus {
  NOT_STARTED = 'NOT_STARTED',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  ABANDONED = 'ABANDONED',
  TERMINATED = 'TERMINATED',
}

export enum SurveyQuestionGroupValidation {
  SINGLE = 'SINGLE',
  ALL = 'ALL',
}

export enum SurveyQuestionType {
  MULTI = 'MULTI',
  SINGLE = 'SINGLE',
  INSTANT = 'INSTANT',
  FORM_NUMBER = 'FORM_NUMBER',
  FORM_TEXT = 'FORM_TEXT',
  FORM_CURRENCY = 'FORM_CURRENCY',
  FORM_TEXT_AREA = 'FORM_TEXT_AREA',
}

export enum SurveyNavigationType {
  FORWARD,
  BACKWARD,
}

export interface SurveyQuestionnairePayload {
  payload: Survey;
}
